











export default {
  name: 'basic-rich',

  props: {
    content: String,
    bindState: [String, Object, Array, Number],
    fontSize: String,
    color: String
  },

  methods: {
    isDef (val: any) {
      return val !== undefined && val !== null && val !== ''
    }
  }
}
